<template>
  <div class="panel" v-if="!loading">
    <div class="main-container">
      <div class="flex">
        <spray-paths-map> </spray-paths-map>
        <sidebar :adulticides="mapAdulticides" :viewingFilters="showFilters">
        </sidebar>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarListItem from './sidebar-list-item.vue';
import Sidebar from './sidebar.vue';
import SprayPathsMap from './spray-paths-map.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    SprayPathsMap,
    Sidebar,
    SidebarListItem,
  },

  computed: {
    ...mapGetters(['mapAdulticides']),
    showFilters() {
      return this.$store.state.sprayPaths.settings.displayFilterSettings;
    },
  },

  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style></style>
